var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrumStick = function SvgDrumStick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.251 32.914a5.691 5.691 0 0 0-10.285-2.708l-3.429-3.429s-.274-.171-.377-.274A19.2 19.2 0 0 0 27.429 6.41a14.23 14.23 0 0 0-21.018 0 14.263 14.263 0 0 0-.137 21.018 19.13 19.13 0 0 0 20.572 4.594 2 2 0 0 0 0 .274l4.011 3.977a5.59 5.59 0 0 0-1.954 4.869 5.704 5.704 0 0 0 11.348-1.166 5.5 5.5 0 0 0-.171-.72h1.063a5.657 5.657 0 0 0 5.108-6.343z"
  })));
};
export default SvgDrumStick;